import React, { useState } from "react";
import { Form, Input, Checkbox, Button, Upload, Avatar, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export default function SponsorForm({ form, onFinish, loading }) {
  const [fileList, setFileList] = useState([]);
  const [preview, setPreview] = useState(null);

  const getBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => cb(reader.result));
    reader.readAsDataURL(file);
  };

  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList);
    const file = fileList?.[0]?.originFileObj;
    if (file) getBase64(file, setPreview);
    else setPreview(null);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      requiredMark={false}
      className="sponsorForm_form"
      onValuesChange={(_, allValues) => {
        const file = allValues.photo?.[0]?.originFileObj;
        if (file) getBase64(file, setPreview);
        else setPreview(null);
      }}
    >
      <div className="sponsorForm_uploadWrapper">
        <Form.Item
          name="photo"
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList}
        >
          <Upload listType="picture" beforeUpload={() => false} maxCount={1}>
            <Button icon={<UploadOutlined />}>Upload Photo</Button>
          </Upload>
        </Form.Item>

        {preview ? (
          <img src={preview} alt="preview" className="sponsorForm_preview" />
        ) : (
          <Avatar size={120} className="sponsorForm_avatar" />
        )}
      </div>

      <div className="sponsorForm_row">
        <Form.Item
          name="first_name"
          label="First Name"
          rules={[{ required: true }]}
          className="sponsorForm_item"
        >
          <Input placeholder="Enter first name" />
        </Form.Item>
        <Form.Item
          name="last_name"
          label="Last Name"
          rules={[{ required: true }]}
          className="sponsorForm_item"
        >
          <Input placeholder="Enter last name" />
        </Form.Item>
        {/* <Form.Item
          name="countrycode"
          label="Country Code"
          initialValue="IN"
          className="sponsorForm_item"
        >
          <Input placeholder="Enter country code (e.g., IN, US)" />
        </Form.Item> */}
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please enter a valid email",
            },
          ]}
          className="sponsorForm_item"
        >
          <Input placeholder="Enter email" />
        </Form.Item>
        <Form.Item
          name="phone"
          label="Phone Number"
          rules={[{ required: true }]}
          className="sponsorForm_item"
        >
          <Input placeholder="Enter phone number" />
        </Form.Item>
      </div>

      <div className="sponsorForm_row">
        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true }]}
          className="sponsorForm_item"
        >
          <Input.Password placeholder="Enter password" />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={["password"]}
          rules={[
            { required: true },
            ({ getFieldValue }) => ({
              validator(_, value) {
                return !value || getFieldValue("password") === value
                  ? Promise.resolve()
                  : Promise.reject(new Error("Passwords do not match"));
              },
            }),
          ]}
          className="sponsorForm_item"
        >
          <Input.Password placeholder="Confirm password" />
        </Form.Item>
      </div>

      {/* <Form.Item
        name="confirmation"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) =>
              value
                ? Promise.resolve()
                : Promise.reject(new Error("Please confirm")),
          },
        ]}
        className="sponsorForm_confirmation"
      >
        <Checkbox>
          I confirm that the information provided is true to the best of my
          knowledge.
        </Checkbox>
      </Form.Item> */}
      <Form.Item
        name="accept_terms"
        valuePropName="checked"
        rules={[
          {
            validator: (_, value) =>
              value
                ? Promise.resolve()
                : Promise.reject("You must accept the terms to continue"),
          },
        ]}
      >
        <Checkbox>
          I agree to the{" "}
          <a href="/consent-of-care" target="_blank">
            Consent of Care
          </a>
          ,{" "}
          <a href="/patient-family-bill-of-rights" target="_blank">
            Patient & Family Bill of Rights
          </a>{" "}
          and{" "}
          <a href="/hipaa-release-privacy" target="_blank">
            HIPAA Release & Privacy Statement
          </a>
          .
        </Checkbox>
      </Form.Item>

      <Form.Item className="sponsorForm_buttons">
        <Button
          type="primary"
          htmlType="submit"
          className="sponsorForm_submitBtn"
        >
          {loading ? (
            <Spin spinning={loading} tip="Please wait..." />
          ) : (
            "Create Sponsor"
          )}
        </Button>
      </Form.Item>
    </Form>
  );
}
